import { useTranslation } from 'react-i18next';

import { HeadsetIcon } from '@/assets/icons/HeadsetIcon';

import styles from './styles.module.css';

export const ViewAdvisorBanner: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.viewAdvisor}>
      <HeadsetIcon height={24} width={24} color="var(--totem-color-white)" />
      <span>{t('common.advisorView')}</span>
    </div>
  );
};
